import { createContext } from 'react';

type ValidationContextType = {
  registerValidation: (fn: () => boolean) => void;
  triggerValidation: () => boolean;
};

export const ValidationContext = createContext<ValidationContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- default no-op before a real provider mounts
  registerValidation: () => {},
  triggerValidation: () => true,
});
